import React from 'react'
import UserHero from './partials/UserHero'
import UserAccount from './partials/UserAccount'
import ListGroup from './partials/ListGroup'
import { MdOutlineMarkEmailRead } from "react-icons/md";
export default function UserSupportPage() {
  return (
    <>
    <UserHero />
          <div className="container">
            <UserAccount />
            <div className="row">
              <ListGroup />
              <div className="col-md-8 col-sm-6 col-12">
              <div className="user-offer-h2">
                        <h2>SUPPORT </h2>
                 </div> 

                <div className="user-support-main">
                    <div className="user-support-left">
                            <div className="gold-pass">
                                <p>GOLD PASS</p>
                                <strong>24-hour dedicated Member Service Assistance -    <a href="tel:+919811320209">  +91 9811320209 </a> </strong>
                            </div>
                            <div className="gold-pass">
                                <p>SILVER PASS</p>
                                <strong>24-hour dedicated Member Service Assistance -<a href="tel:+919811226576"> +91 9811226576 </a>
                                </strong>
                            </div>
                            <div className="gold-pass">
                                <p>PLATINUM PASS</p>
                                <strong>from 9:00 am to 6:00 pm 
                                    <a href="tel:+916547893321"> +91 6547893321 </a>
                                </strong>
                            </div>
                    </div>
               <div className="user-support-right">
                                    <div className="user-support-email">
                                        <p><MdOutlineMarkEmailRead className='me-2' />Emial ID:</p>
                                        <strong>  
                                            <a href="mailto:info@vhotelthegrandshoba.com">info@vhotelthegrandshoba.com</a>          
                                        </strong>
                                    </div>
                                    <div className="user-support-email">
                                        <p><MdOutlineMarkEmailRead className='me-2' />Emial ID:</p>
                                        <strong>
                                        <a href="mailto:booking@vhotelthegrandshoba.com">booking@vhotelthegrandshoba.com</a>          
                                        </strong>
                                    </div>
                   </div>

                </div>

                 
              </div>
              
            </div>
          </div>
    </>
  )
}
